import i18n from '../../i18n';

export const ParticipantVerificationStatus = {
  notVerified: 'notVerified',
  verifying: 'verifying',
  verified: 'verified',
};

export const getStatusesWithLabels = () => ({
  notVerified: {
    value: 'notVerified',
    name: i18n.t('auth.participantAccounts.participantVerificationStatus.notVerified'),
  },
  verifying: {
    value: 'verifying',
    name: i18n.t('auth.participantAccounts.participantVerificationStatus.verifying'),
  },
  verified: {
    value: 'verified',
    name: i18n.t('auth.participantAccounts.participantVerificationStatus.verified'),
  },
});



// WEBPACK FOOTER //
// ./src/models/auth/ParticipantVerificationStatus.js